import React from 'react';
import { List } from 'semantic-ui-react'
import {flowRight as compose} from 'lodash';
import general from '../../../modulos/general';
import {graphql} from 'react-apollo';

//utils
import queries from '../../../utils/queries'

import TitDer from '../../../components/funcionales/titder';

// import EstilosHome from '../../css/home.css';

const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => {
  return (
    <tr className='' onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaCreate.substr(0, 10)}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numCoti}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.referencia}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.nombreUsuario}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
      {/* <td className='right aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.valorUniAprob?general.formatNum(elemento.valorUniAprob.toString()):0}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidadAprob?general.formatNum(elemento.cantidadAprob.toString()):0}</td> */}
      <td className='right aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.valorUniAprob?new Intl.NumberFormat('de-DE').format(elemento.valorUniAprob):0}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidadAprob?new Intl.NumberFormat('de-DE').format(elemento.cantidadAprob):0}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estadoCoti}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.zonaFranca?elemento.zonaFranca:""}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.gestionIngreso?elemento.gestionIngreso:""}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.observaciones}</td>
   </tr>  
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento}
        handleClickidLista={handleClickidLista}
        key={elemento._id}/>
  )
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class AdminCotizacion2 extends React.Component { 
  state = {argsBuscCad: {}, 
    argsQuery: `{$match: {tipoCoti: 'Cliente', estadoCoti: 'Creada'}},
    {$project: {_id: 1, 
      itemsCoti: {
        $let: {
          vars: {regItem: { $cond: { if: { $isArray: "$itemsCoti" },
                                        then: { $size: "$itemsCoti" },
                                        else: 0} }
          },
          in: { $cond: { if: { $gt: [ "$$regItem", 0 ] },
                              then: "$itemsCoti",
                              else: [{cantidadAprob: 0, valorUniAprob: 0, porcIVA: 0, porcDcto: 0, porcIncremento: 0}] 
          }}
      }},      
      fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
      monedaCoti: 1, imptoCoti: 1, zonaFranca: 1, gestionIngreso: 1, pais: 1, 
	    descrPolitica: 1, tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, ciudadContacto: 1,
	    mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, validezOferta: 1, observacionesAut: 1, usuarioAut: 1,
      estadoCoti: 1, observaciones: 1, titulo2: 1, parrafo2: 1, titulo3: 1, parrafo3: 1, ciudad: 1, email: 1, telefono: 1}},
    {"$unwind": "$itemsCoti"},
    {$project: {_id: 1, fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
      descrPolitica: 1, tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, 
      monedaCoti: 1, imptoCoti: 1, zonaFranca: 1, gestionIngreso: 1, pais: 1, 
      ciudadContacto: 1, mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, 
      validezOferta: 1, observacionesAut: 1, usuarioAut: 1, estadoCoti: 1, observaciones: 1, titulo2: 1, 
      parrafo2: 1, titulo3: 1, parrafo3: 1, ciudad: 1, email: 1, telefono: 1,
      cantidadAprob: '$itemsCoti.cantidadAprob', porcIncremento: '$itemsCoti.porcIncremento',
      valorUniAprob: '$itemsCoti.valorUniAprob', porcIVA: '$itemsCoti.porcIVA', porcDcto: '$itemsCoti.porcDcto'}},   
    {$project: {_id: 1, fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
      descrPolitica: 1, tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, 
      monedaCoti: 1, imptoCoti: 1, zonaFranca: 1, gestionIngreso: 1, pais: 1, 
      ciudadContacto: 1, mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, 
      validezOferta: 1, observacionesAut: 1, usuarioAut: 1, estadoCoti: 1, observaciones: 1, titulo2: 1, 
      parrafo2: 1, titulo3: 1, parrafo3: 1, ciudad: 1, email: 1, telefono: 1,
      valorItem: {
        $let: {
            vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcDcto: {$toInt: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
            in: { $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}
        }
      },
      valorItemIVA: {
        $let: {
          vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcIVA: {$toInt: '$porcIVA'}, porcDcto: {$toInt: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
          in: { $multiply: [{ $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}, {$add: [1, {$divide: [ "$$porcIVA", 100 ]} ]}]}
        }
      }
    }},
    {$group: {_id: {_id: '$_id', fechaCreate: '$fechaCreate', numCoti: '$numCoti', nombreUsuario: '$nombreUsuario', titulo: '$titulo',
    fechaAut: '$fechaAut', fechaEnvio: '$fechaEnvio', fechaRta: '$fechaRta', pais: '$pais', 
    monedaCoti: '$monedaCoti', imptoCoti: '$imptoCoti', zonaFranca: '$zonaFranca', gestionIngreso: '$gestionIngreso', 
descrPolitica: '$descrPolitica', tipo: '$tipo', ciudadFechaEnvio: '$ciudadFechaEnvio', 
    descrEmpresa: '$descrEmpresa', cedula: '$cedula', nombreContacto: '$nombreContacto', 
    cargoContacto: '$cargoContacto', 
ciudadContacto: '$ciudadContacto', mailContacto: '$mailContacto', telContacto: '$telContacto', 
    referencia: '$referencia', tiempoEntrega: '$tiempoEntrega', lugarEntrega: '$lugarEntrega', 
    formaPago: '$formaPago', 
validezOferta: '$validezOferta', observacionesAut: '$observacionesAut', usuarioAut: '$usuarioAut', 
    estadoCoti: '$estadoCoti', observaciones: '$observaciones', titulo2: '$titulo2', 
    parrafo2: '$parrafo2', titulo3: '$titulo3', parrafo3: '$parrafo3', ciudad: '$ciudad', email: '$email', telefono: '$telefono'},
  valorTotal: {$sum: {$toDouble: '$valorItem'}}, valorTotalIVA: {$sum: {$toDouble: '$valorItemIVA'}}
}},
{$project: {_id: '$_id._id', fechaCreate: "$_id.fechaCreate",
      numCoti: '$_id.numCoti', nombreUsuario: '$_id.nombreUsuario', titulo: "$_id.titulo",
      fechaAut: '$_id.fechaAut', fechaEnvio: '$_id.fechaEnvio', pais: '$_id.pais', 
      monedaCoti: '$_id.monedaCoti', imptoCoti: '$_id.imptoCoti', zonaFranca: '$_id.zonaFranca', gestionIngreso: '$_id.gestionIngreso', 
      fechaRta: '$_id.fechaRta', descrPolitica: '$_id.descrPolitica', tipo: '$_id.tipo', 
        ciudadFechaEnvio: '$_id.ciudadFechaEnvio', descrEmpresa: '$_id.descrEmpresa', cedula: '$_id.cedula', 
        nombreContacto: '$_id.nombreContacto', cargoContacto: '$_id.cargoContacto', 
ciudadContacto: '$_id.ciudadContacto', mailContacto: '$_id.mailContacto', telContacto: '$_id.telContacto', 
        referencia: '$_id.referencia', tiempoEntrega: '$_id.tiempoEntrega', lugarEntrega: '$_id.lugarEntrega', 
        formaPago: '$_id.formaPago', 
validezOferta: '$_id.validezOferta', observacionesaAut: '$_id.observacionesAut', usuarioAut: '$_id.usuarioAut', 
        estadoCoti: '$_id.estadoCoti', observaciones: '$_id.observaciones', titulo2: '$_id.titulo2', 
        parrafo2: '$_id.parrafo2', titulo3: '$_id.titulo3', parrafo3: '$_id.parrafo3', ciudad: '$_id.ciudad', email: '$_id.email', telefono: '$_id.telefono',
        valorUniAprob: {$toDouble: '$valorTotal'}, cantidadAprob: {$toDouble: '$valorTotalIVA'}
    }}`
  }
  async componentDidUpdate (prevProps){
    if(this.props.argsBuscCad!==prevProps.argsBuscCad){
      let argsBuscar = `'estadoCoti': 'Creada'`

      if(this.props.argsBuscCad.descrEmpresa){
        argsBuscar += `, 'descrEmpresa': /${this.props.argsBuscCad.descrEmpresa}/i`
      }          
      if(this.props.argsBuscCad.numCoti){
        argsBuscar += `, 'numCoti': /${this.props.argsBuscCad.numCoti}/i`
      }
      if(this.props.argsBuscCad.nombreUsuario){
        argsBuscar += `, 'nombreUsuario': /${this.props.argsBuscCad.nombreUsuario}/i`
      }
      let argsBuscCad = ""
      
      argsBuscCad = `{$match: {${argsBuscar}}}, {$sort: {fechaCreate: -1}}`
      
      let argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, ${argsBuscCad}]`}
      console.log(argsBuscarIt)
      await this.props.allCotizacionRtesCot.refetch(argsBuscarIt)
    }
  }

  render(){
// const AdminCotizacion2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a352501 = this.props.autorizacUA.findIndex( autorizac => autorizac === "352501" );
  let list = []
  if(this.props.allCotizacionRtesCot.allCotizacionRtes){
    this.props.allCotizacionRtesCot.refetch()
    list = this.props.allCotizacionRtesCot.allCotizacionRtes
  }
  console.log(list)
    return (
      <div>
        <List selection>
          <TitDer list={list} textBoton1="Cotizaciones para clientes" btnNuevo={a352501!==-1?"SI":"NO"} styles={this.props.styles} handleClick={this.props.handleClick} />
          
          <div style={{height: '35em', overflow: 'auto'}}>
            <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
              <thead className=''>
                <tr className=''> 
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Creada</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '22%'}}>Cotización</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '30%'}}>Referencia</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Responsable</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Cliente</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Valor sin IVA</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Valor con IVA</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Estado</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Cliente en zona franca</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Gestionar ingreso</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '85%'}}>Observaciones</th>
                </tr>
              </thead>
              <Lista list={list} handleClickidLista={this.props.handleClickidLista}/>
            </table>
            <p></p>
          </div>
        </List>

      </div>
    )
  }
};

export default compose(
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesCot',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estadoCoti: 'Creada'}}, {$sort: {fechaCreate: -1}},
    {$project: {_id: 1, 
      itemsCoti: {
        $let: {
          vars: {regItem: { $cond: { if: { $isArray: "$itemsCoti" },
                                        then: { $size: "$itemsCoti" },
                                        else: 0} }
          },
          in: { $cond: { if: { $gt: [ "$$regItem", 0 ] },
                              then: "$itemsCoti",
                              else: [{cantidadAprob: 0, valorUniAprob: 0, porcIVA: 0, porcDcto: 0, porcIncremento: 0}] 
          }}
      }},      
      fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
      monedaCoti: 1, imptoCoti: 1, zonaFranca: 1, gestionIngreso: 1, pais: 1, 
	    descrPolitica: 1, tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, ciudadContacto: 1,
	    mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, validezOferta: 1, observacionesAut: 1, usuarioAut: 1,
      estadoCoti: 1, observaciones: 1, titulo2: 1, parrafo2: 1, titulo3: 1, parrafo3: 1, ciudad: 1, email: 1, telefono: 1}
    },
    {"$unwind": "$itemsCoti"},
    {$project: {_id: 1, fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
      monedaCoti: 1, imptoCoti: 1, zonaFranca: 1, gestionIngreso: 1, pais: 1, 
      descrPolitica: 1, tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, 
      ciudadContacto: 1, mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, 
      validezOferta: 1, observacionesAut: 1, usuarioAut: 1, estadoCoti: 1, observaciones: 1, titulo2: 1, 
      parrafo2: 1, titulo3: 1, parrafo3: 1, ciudad: 1, email: 1, telefono: 1,
      cantidadAprob: '$itemsCoti.cantidadAprob', porcIncremento: '$itemsCoti.porcIncremento',
      valorUniAprob: '$itemsCoti.valorUniAprob', porcIVA: '$itemsCoti.porcIVA', porcDcto: '$itemsCoti.porcDcto'}},   
    {$project: {_id: 1, fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
      descrPolitica: 1, tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, 
      monedaCoti: 1, imptoCoti: 1, zonaFranca: 1, gestionIngreso: 1, pais: 1, 
      ciudadContacto: 1, mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, 
      validezOferta: 1, observacionesAut: 1, usuarioAut: 1, estadoCoti: 1, observaciones: 1, titulo2: 1, 
      parrafo2: 1, titulo3: 1, parrafo3: 1, ciudad: 1, email: 1, telefono: 1,
      valorItem: {
        $let: {
            vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcDcto: {$toInt: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
            in: { $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}
        }
      },
      valorItemIVA: {
        $let: {
          vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcIVA: {$toInt: '$porcIVA'}, porcDcto: {$toInt: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
          in: { $multiply: [{ $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}, {$add: [1, {$divide: [ "$$porcIVA", 100 ]} ]}]}
        }
      }
    }},
{$group: {_id: {_id: '$_id', fechaCreate: '$fechaCreate', numCoti: '$numCoti', nombreUsuario: '$nombreUsuario', titulo: '$titulo',
    fechaAut: '$fechaAut', fechaEnvio: '$fechaEnvio', fechaRta: '$fechaRta', monedaCoti: '$monedaCoti', imptoCoti: '$imptoCoti',
    descrPolitica: '$descrPolitica', tipo: '$tipo', ciudadFechaEnvio: '$ciudadFechaEnvio', zonaFranca: '$zonaFranca', gestionIngreso: '$gestionIngreso', 
    descrEmpresa: '$descrEmpresa', cedula: '$cedula', nombreContacto: '$nombreContacto', 
    cargoContacto: '$cargoContacto', pais: '$pais', 
    ciudadContacto: '$ciudadContacto', mailContacto: '$mailContacto', telContacto: '$telContacto', 
    referencia: '$referencia', tiempoEntrega: '$tiempoEntrega', lugarEntrega: '$lugarEntrega', 
    formaPago: '$formaPago', 
    validezOferta: '$validezOferta', observacionesAut: '$observacionesAut', usuarioAut: '$usuarioAut', 
    estadoCoti: '$estadoCoti', observaciones: '$observaciones', titulo2: '$titulo2', 
    parrafo2: '$parrafo2', titulo3: '$titulo3', parrafo3: '$parrafo3', ciudad: '$ciudad', email: '$email', telefono: '$telefono'},
  valorTotal: {$sum: {$toDouble: '$valorItem'}}, valorTotalIVA: {$sum: {$toDouble: '$valorItemIVA'}}
}},
{$project: {_id: '$_id._id', fechaCreate: "$_id.fechaCreate",
      numCoti: '$_id.numCoti', nombreUsuario: '$_id.nombreUsuario', titulo: "$_id.titulo",
      fechaAut: '$_id.fechaAut', fechaEnvio: '$_id.fechaEnvio', pais: '$_id.pais', 
      monedaCoti: '$_id.monedaCoti', imptoCoti: '$_id.imptoCoti', zonaFranca: '$_id.zonaFranca', gestionIngreso: '$_id.gestionIngreso', 
      fechaRta: '$_id.fechaRta', descrPolitica: '$_id.descrPolitica', tipo: '$_id.tipo', 
        ciudadFechaEnvio: '$_id.ciudadFechaEnvio', descrEmpresa: '$_id.descrEmpresa', cedula: '$_id.cedula', 
        nombreContacto: '$_id.nombreContacto', cargoContacto: '$_id.cargoContacto', 
ciudadContacto: '$_id.ciudadContacto', mailContacto: '$_id.mailContacto', telContacto: '$_id.telContacto', 
        referencia: '$_id.referencia', tiempoEntrega: '$_id.tiempoEntrega', lugarEntrega: '$_id.lugarEntrega', 
        formaPago: '$_id.formaPago', 
validezOferta: '$_id.validezOferta', observacionesaAut: '$_id.observacionesAut', usuarioAut: '$_id.usuarioAut', 
        estadoCoti: '$_id.estadoCoti', observaciones: '$_id.observaciones', titulo2: '$_id.titulo2', 
        parrafo2: '$_id.parrafo2', titulo3: '$_id.titulo3', parrafo3: '$_id.parrafo3', ciudad: '$_id.ciudad', email: '$_id.email', telefono: '$_id.telefono',
        valorUniAprob: {$toDouble: '$valorTotal'}, cantidadAprob: {$toDouble: '$valorTotalIVA'}
    }}        
    ]`}}}}),


)(AdminCotizacion2) 